import Model from "./base/model";

class ReportValuesByTargetState extends Model {
  resourceName() {
    return "report_values_target_state";
  }

  fields() {
    return {
      uf: "",
      total_solicitations: "",
      total_value_nf: "",
      total_weight_nf: "",
      total_value_freight: "",
      from_date: "",
      until_date: "",
      shipper_ids: "",
      transporter_ids: "",
      supplier_ids: "",
      full_truckload: "",
      less_than_truckload: ""
    };
  }

  async valuesByTargetState(filters) {
    return this.request(
      this.resourceName(),
      "POST",
      {},
      filters,
    );
  }
}


export default new ReportValuesByTargetState();
